<template lang='pug'>
v-container.pa-0(fluid)
  v-app-bar(app, flat, dense, fixed)
    v-app-bar-nav-icon(@click="toggleDrawerMenu")
    v-toolbar-title.subtitle-1 掲示板
  v-container(fluid)
    v-row
      table.information-board-table.ma-3
        colgroup
          col
          col(style="width: 30%")
          col(style="width: 30%")
          col
          col
          col
          col
        tr
          th 終了時刻
          th メッセージ
          th URL
          th 色
          th 対象者
          th 更新者
          th
            v-btn(color="primary", small, @click="prepareToAdd") 掲示板追加
        tr(v-for="item in informations", :key="item.informationBoardId")
          td {{ item.ended }}
          td {{ item.message }}
          td {{ item.url }}
          td {{ item.color }}
          td {{ item.targetTagName }}
          td {{ item.updatedBy }}
          td 
            v-btn(color="primary", text, small, @click="prepareToEdit(item)") 修正
            v-btn(
              color="secondary",
              text,
              small,
              @click="finishInformation(item)"
            ) 掲示終了
            v-btn(color="error", text, small, @click="prepareToDelete(item)") 削除
    v-dialog(v-model="dialogDeleting", max-width="400")
      v-card
        v-card-title Koos Workspace
        v-card-text 掲示板メッセージを削除してよろしいですか。
        v-card-text {{ dialogDeleting.message }}
        v-card-actions
          v-spacer
          v-btn(text, @click="dialogDeleting = false") キャンセル
          v-btn(text, @click="deleteInformation(objectToDelete)") OK

    v-dialog(v-model="dialogAdding", max-width="400")
      v-card
        v-card-title Koos Workspace
        v-card-text 掲示板メッセージを追加します。
        v-card-text
          .list-input-group
            v-card.timecell(
              min-width="90",
              width="90",
              flat,
              v-if="dateStyle != 'input'"
            )
              v-menu(
                v-model="addingObj.datemenu",
                :close-on-content-click="false",
                transition="scale-transition",
                offset-y
              )
                template(v-slot:activator="{ on }")
                  v-text-field(
                    v-model="addingObj.endedDate",
                    label="終了日",
                    v-on="on",
                    dense,
                    width="120",
                    hide-details="auto",
                    @change="checkDateAndTime(addingObj)"
                  )
                v-date-picker(
                  v-model="addingObj.endedDate",
                  @input="addingObj.datemenu = false; checkDateAndTime(addingObj)",
                  no-title
                )
            v-card.timecell.pr-3(
              min-width="90",
              width="90",
              flat,
              v-if="dateStyle == 'input'"
            )
              v-text-field(
                v-model="addingObj.endedDate",
                type="date",
                label="終了日",
                dense,
                hide-details="auto",
                @change="checkDateAndTime(addingObj)"
              )

            v-card.timecell.pr-3(
              min-width="70",
              width="70",
              flat,
              v-if="timeStyle == 'time'"
            )
              v-text-field.centered-input(
                v-model="addingObj.endedTime",
                type="time",
                label="終了時間",
                dense,
                hide-details="auto",
                @change="checkDateAndTime(addingObj)"
              )
            v-card.timecell.pr-3(
              min-width="70",
              width="70",
              flat,
              v-if="timeStyle != 'time'"
            )
              v-text-field.centered-input(
                v-model="addingObj.endedTime2",
                type="text",
                label="終了時間",
                dense,
                hide-details="auto",
                @change="checkTimeInput(addingObj, 'endedTime2')",
                maxlength="5"
              )
        v-card-text
          v-text-field(v-model="addingObj.message", label="メッセージ") 
          v-text-field(v-model="addingObj.url", label="URL") 
          v-select(
            :items="colors",
            item-text="name",
            item-value="value",
            v-model="addingObj.color",
            dense,
            label="カラー"
          )
          v-select(
            :items="tags",
            item-text="name",
            item-value="memberTagId",
            v-model="addingObj.targetTagId",
            dense,
            label="対象タグ",
            clearable
          )
        v-card-actions
          v-spacer
          v-btn(text, @click="dialogAdding = false") キャンセル
          v-btn(text, @click="confirmAdding") OK
</template>

<script>
import basic from "@/components/mixins/basic";
import moment from "moment-timezone";
import { detect } from "detect-browser";
moment.locale("ja");

export default {
  mixins: [basic],
  components: {},
  computed: {
    firstCalendars() {
      return this.members.length > 0 ? this.members[0].dates : [];
    },
  },
  data() {
    return {
      informations: [],
      tags: [],
      colors: [
        { name: "赤", value: "red" },
        { name: "オレンジ", value: "orange" },
        { name: "緑", value: "green" },
        { name: "青", value: "blue" },
        { name: "紫", value: "purple" },
      ],
      targetDate: null,
      startDay: null,
      endDay: null,
      dialogWorkType: false,
      dateStyle: "picker",
      timeStyle: "text",
      addingObj: {},
      dialogAdding: false,
      objectToDelete: {},
      dialogDeleting: false,
    };
  },
  mounted() {
    this.browser = detect();
    if (this.browser !== null) {
      if (
        this.browser.os.includes("iOS") ||
        this.browser.os.includes("Android")
      ) {
        this.dateStyle = "input";
        this.timeStyle = "time";
      }
    }
    this.yearMonthDate = moment([moment().year(), moment().month(), 1]);
  },
  methods: {
    async masterReady() {
      if (!this.$store.getters["Login/isAdmin"]) {
        // redirect to home when you are not admin
        this.$router.push(this.site.deployFolder + "/");
      }
      this.tags = await this.$store.dispatch("MemberTags/listAll", 2);
      await this.search();
    },
    async search() {
      this.informations = await this.$store.dispatch(
        "InformationBoard/listAll",
        {}
      );
      this.informations.forEach((element) => {
        element.targetTagName = this.tags.reduce((prev, current) => {
          return (
            prev +
            (current.memberTagId == element.targetTagId ? current.name : "")
          );
        }, "");
      });
    },
    prepareToAdd() {
      this.addingObj = {
        color: "green",
        url: "",
        message: "",
        ended: null,
        informationBoardId: "",
        targetTagId: null,
      };
      this.dialogAdding = true;
    },
    prepareToDelete(item) {
      this.objectToDelete = item;
      this.dialogDeleting = true;
    },
    prepareToEdit(item) {
      this.addingObj = JSON.parse(JSON.stringify(item));
      this.dialogAdding = true;
    },
    async confirmAdding() {
      this.dialogAdding = false;
      var endedTimeGMT =
        this.addingObj.ended == null
          ? null
          : moment(this.addingObj.ended).utc().format("YYYY-MM-DD HH:mm");
      this.requestParam = {
        endedTimeGMT,
        message: this.addingObj.message,
        url: this.addingObj.url,
        color: this.addingObj.color,
        targetTagId: this.addingObj.targetTagId,
        informationBoardId: this.addingObj.informationBoardId,
      };
      await this.$store.dispatch("InformationBoard/add", this.requestParam);
      this.dialogWorkType = false;
      this.dispSuccess("掲示板にメッセージを追加しました。");
      this.search();
    },
    async checkDateAndTime(object) {
      var endedDate =
        object.endedDate == null || object.endedDate == ""
          ? null
          : moment(object.endedDate);
      var endedTime = null;
      if (this.timeStyle == "text") {
        endedTime =
          object.endedTime2 == null || object.endedTime2 == ""
            ? null
            : object.endedTime2.split(":");
      } else {
        endedTime =
          object.endedTime == null || object.endedTime == ""
            ? null
            : object.endedTime.split(":");
      }
      if (endedTime != null && endedTime.length != 2) {
        object.endedTime = null;
        object.endedTime2 = null;
      }
      if (endedTime != null && endedDate != null) {
        object.ended = moment({
          year: endedDate.year(),
          month: endedDate.month(),
          date: endedDate.date(),
          hour: endedTime[0],
          minute: endedTime[1],
          second: 0,
          millisecond: 0,
        }).format("YYYY-MM-DD HH:mm");
      }
    },
    checkTimeInput(object, column) {
      var time = object[column];
      if (time == null) {
        object[column] = null;
        return;
      }
      if (!time.match("^[/0-9:]*$")) {
        object[column] = null;
        return;
      }
      if (time.length > 5) {
        time = object[column].substring(0, 5);
      }
      var array = time.split(":");
      if (array.length > 2) {
        object[column] = null;
        return;
      }
      if (time.length < 3) {
        object[column] = null;
        return;
      }
      if (array.length == 1 && time.length == 5) {
        object[column] = null;
        return;
      }
      if (array.length == 1 && time.length == 3) {
        time = "0" + object[column];
      }
      if (array.length != 2 && time.length == 4 && time.match("^[/0-9]*$")) {
        array = [time.substring(0, 2), time.substring(2)];
      }
      if (array.length != 2) {
        object[column] = null;
        return;
      }
      var hour = parseInt(array[0]);
      var minute = parseInt(array[1]);
      if (hour > 23 || hour < 0) {
        object[column] = null;
        return;
      }
      if (minute > 59 || minute < 0) {
        object[column] = null;
        return;
      }
      object[column] =
        hour.toString().padStart(2, "0") +
        ":" +
        minute.toString().padStart(2, "0");
      this.checkDateAndTime(object);
    },
    async finishInformation(item) {
      await this.$store.dispatch(
        "InformationBoard/finish",
        item.informationBoardId
      );
      this.dialogWorkType = false;
      this.dispSuccess("メッセージの掲示を終了しました。");
      this.search();
    },
    async deleteInformation(item) {
      await this.$store.dispatch(
        "InformationBoard/delete",
        item.informationBoardId
      );
      this.dialogDeleting = false;
      this.dispSuccess("メッセージを削除しました。");
      this.search();
    },
    toggleDrawerMenu() {
      this.$emit("toggle");
    },
  },
};
</script>

<style>
.timerow {
  border-bottom-style: solid;
  border-bottom-width: 1pt;
  border-bottom-color: lightgray;
}
.timecell {
  background-color: transparent !important;
}
.odd {
  background-color: rgb(232, 232, 232);
}
.user-table td {
  padding-top: 3px;
  padding-bottom: 3px;
}
.user-image {
  width: 40px;
  height: 40px;
  border-radius: 20%;
  border-style: solid;
  border-width: 0.5px;
  border-color: lightgray;
}
.inactive {
  -webkit-filter: grayscale() opacity(0.5);
  filter: grayscale() opacity(0.5);
}
/* .timeinput fieldset {
  border-color: rgb(210, 210, 210) !important;
  height: 41px !important;
  background-color: white !important;
}
*/
.timesheet-table {
  width: 100%;
}

label.v-label {
  font-size: 0.8em !important;
}
.centered-input input {
  text-align: center;
}
.member-plan-cell {
  font-size: 0.7em;
}
.information-board-table {
  width: 100%;
  padding: 0em 2em;
  border-collapse: collapse;
  border-left-style: solid;
  border-left-width: 1px;
  border-left-color: #ccc;
  border-top-style: solid !important;
  border-top-width: 1px;
  border-top-color: #ccc;
}
.information-board-table td {
  border-bottom-style: solid !important;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  border-left-style: none;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #ccc;
  margin-right: 5px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  word-wrap: break-word;
  word-break: break-all;
}
.information-board-table th {
  border-bottom-style: solid !important;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  border-left-style: none;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #ccc;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.approve-title {
  font-weight: bold;
  color: black !important;
}
.list-input-group {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  align-items: center;
  min-height: 2rem;
}
</style>